/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Absences_ReasonInputs */

const en_tables_absences_reason = /** @type {(inputs: Tables_Absences_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason`)
};

const de_tables_absences_reason = /** @type {(inputs: Tables_Absences_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grund`)
};

/**
* | output |
* | --- |
* | "Reason" |
*
* @param {Tables_Absences_ReasonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_absences_reason = /** @type {((inputs?: Tables_Absences_ReasonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Absences_ReasonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_absences_reason(inputs)
	return de_tables_absences_reason(inputs)
});